/*
 * Project: forca
 * File Created: Wednesday, 12th January 2022 12:49:26 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import SectionHeading from '@Components/sectionHeading';
import Image from '@Components/image';

import isMobile from '@Utils/isMobile';

import { KarruselComponentProps, KarruselSlide } from './Karrusel.definition';

export const Karrusel = (props: KarruselComponentProps) => {
	const { title, subtitle, linkText, link, items = [], activeSlide, isTransparent = false, elementMargin } = props;

	const renderStaticButton = () => (
		<a
			className={ [
				'square-button',
				isTransparent ? 'button-type-3' : 'button-type-2'
			].join(' ') }
			href={ link }
			title={ linkText }
		>
			{ linkText }
		</a>
	);

	const renderButton = (item: KarruselSlide, i: number) => {
		const { changeActiveSlide } = props;
		const { buttonText } = item;

		if (isMobile.any()) {
			return (
				<button
					key={ i }
					className={ [
						'inline-button',
						'Karrusel-Button',
						'Karrusel-Button--isActive'
					].join(' ') }
					type="button"
				>
					{ buttonText }
				</button>
			);
		}

		return (
			<button
				key={ i }
				className={ [
					'inline-button',
					'Karrusel-Button',
					activeSlide === i ? 'Karrusel-Button--isActive' : ''
				].join(' ') }
				type="button"
				onClick={ () => changeActiveSlide(i) }
			>
				{ buttonText }
			</button>
		);
	};

	const renderButtons = (items: KarruselSlide[]) => (
		<div>
			{ items.map((item: KarruselSlide, i: number) => renderButton(item, i)) }
		</div>
	);

	const renderSlide = (item: KarruselSlide, i: number) => {
		const { image, buttonText } = item;

		let style: any = {
			width: 100 / items.length + '%'
		};

		if (isMobile.any() && i !== (items.length - 1)) {
			style = {
				width: 100 / items.length + '%',
				marginRight: 20 + 'px'
			};
		}

		return (
			<div key={ i } style={ style }>
				<Image className="Karrusel-Image" src={ image } alt={ buttonText } ratio="sqaure" />
				{ isMobile.any() && renderButton(item, i) }
			</div>
		);
	};

	let style = {};

	if (!isMobile.any()) {
		style = {
			width: 100 * items.length + '%',
			marginLeft: -100 * activeSlide + '%'
		};
	} else {
		style = {
			width: (100 - 10) * items.length + '%'
		};
	}

	return (
		<div
			className={ [
				'Karrusel',
				isTransparent ? 'Karrusel--transparent' : '',
				elementMargin ? `mb-${elementMargin}` : ''
			].join(' ') }>
			<SectionHeading headline={ title } subheadline={ subtitle } headlineSize="medium" alignLeft headlineColor={ isTransparent ? '#222' : '#fff' } />

			{ /* // if desktop view else mobile view */ }
			{ !isMobile.any() ? (
				<div className="Karrusel-Container">
					<div className="Karrusel-Buttons">
						{ renderStaticButton() }
						{ renderButtons(items) }
					</div>
					<div className="Karrusel-SlideWrapper">
						<div className="Karrusel-Slider" style={ style }>
							{ items.map((item: KarruselSlide, i: number) => renderSlide(item, i)) }
						</div>
					</div>
				</div>
			) : (
				<>
					{ renderStaticButton() }
					<div className="Karrusel-SlideWrapper">
						<div className="Karrusel-Slider" style={ style }>
							{ items.map((item: KarruselSlide, i: number) => renderSlide(item, i)) }
						</div>
					</div>
				</>
			) }
		</div>
	);
};

export default Karrusel;